import { widgetViewNames } from 'src/constants/widgets';

/**
 * @return {boolean}
 */
export const isRescueNet = state =>
  state.widgetView.name === widgetViewNames.rescueNet;
